export default __webpack_public_path__ + "static/media/santorini.23bc8fa0.png";